:host {
    display: flex;
    position: relative;

    .username {
        @include typo-ws-paragraph-bold;

        color: $color-white;
        margin-right: 4px;
        align-self: center;
        white-space: nowrap;
        cursor: pointer;
    }

    .header-button {
        all: unset;
        position: relative;
        cursor: pointer;
        display: block;

        .svg {
            width: 32px;
            color: $color-white;
        }

        &::before {
            opacity: 0;
            transition:
                opacity 200ms,
                bottom 200ms;
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -38px;
            border: solid $color-white;
            border-width: 0 16px 20px;
            border-color: transparent transparent $color-white;
            z-index: 1;
            display: var(--arrow-display, block);
            pointer-events: none;
        }

        &.open::before {
            transition-duration: 400ms;
            transition-delay: 200ms;
            bottom: -26px;
            opacity: 1;
        }

        .counter {
            @include typo-ws-paragraph-s-bold;

            line-height: 16px;
            padding: 0 2px;
            min-width: 16px;
            text-align: center;
            position: absolute;
            color: $color-white;
            background-color: $color-red;
            box-sizing: border-box;
            border-radius: 4px;
            top: -6px;
            left: 100%;
            transform: translateX(-70%);
            white-space: nowrap;
        }
    }

    @keyframes slidedown {
        from {
            opacity: 0;
            height: 0;
        }

        99% {
            height: var(--flyout-height);
        }

        to {
            opacity: 1;
            height: auto;
        }
    }

    .flyout-content {
        box-shadow: var(--shadow-medium);
        background-color: $color-white;
        position: absolute;
        top: 50px;
        width: 360px;
        right: var(--right);
        box-sizing: content-box;
        overflow: hidden;

        button {
            all: unset;
            display: none;
            position: absolute;
            top: 20px;
            right: 20px;
            width: 28px;
            color: var(--color-icon-default);
            cursor: pointer;
            outline-offset: -1px;

            &:focus {
                outline: 2px solid var(--color-border-interaction-focus);
                outline-offset: 2px;
            }
        }

        &.open {
            opacity: 1;
            height: auto;
            overflow: visible;

            button {
                display: block;
            }
        }

        &.open-animation {
            animation: slidedown 500ms forwards;
        }

        &.close {
            opacity: 0;
            height: 0;
        }

        &.close-animation {
            animation: slidedown 500ms reverse backwards;
            overflow: hidden;
        }
    }

    .content-wrapper {
        padding: 44px 32px 40px;
    }
}

@include mq-3-min {
    :host([fullscreen]) {
        .flyout-content {
            button {
                right: 32px;
                top: 32px;
                width: 34px;
            }
        }

        .content-wrapper {
            padding-right: 120px;
            padding-left: 120px;
        }
    }
}

@include mq-2 {
    :host([fullscreen]) {
        .content-wrapper {
            padding-right: 60px;
            padding-left: 60px;
        }
    }
}

@mixin fullscreen {
    .flyout-content {
        width: auto;
        left: var(--left);
    }
}

@include mq-1 {
    :host {
        @include fullscreen;

        .username {
            display: none;
        }

        .content-wrapper {
            padding-right: 20px !important;
            padding-left: 20px !important;
        }
    }
}

:host([fullscreen]) {
    @include fullscreen;
}
